
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    weapon: 'Weapon',
    sticker: 'Sticker',
    graffiti: 'Graffiti',
    case: 'Case',
    capsule: 'Capsule',
    package: 'Package',
    collection: 'Collection',
    musicKit: 'Music kit',
    patch: 'Patch',
    charm: 'Charm',
    agent: 'Agent',
    knife: 'Knife',
    gloves: 'Gloves',
    item: 'Item',
    condition: 'Condition',
    color: 'Color',
  },
  ru: {
    weapon: 'Оружие',
    sticker: 'Стикер',
    graffiti: 'Граффити',
    case: 'Кейс',
    capsule: 'Капсула',
    package: 'Набор',
    collection: 'Коллекция',
    musicKit: 'Музыкальный набор',
    patch: 'Нашивка',
    charm: 'Брелок',
    agent: 'Агент',
    knife: 'Нож',
    gloves: 'Перчатки',
    item: 'Предмет',
    condition: 'Состояние',
    color: 'Цвет',
  },
  uz: {
    weapon: 'Qurol',
    sticker: 'Stiker',
    graffiti: 'Grafitti',
    case: 'Quti',
    capsule: 'Kapsula',
    package: 'Toplam',
    collection: 'Kolleksiya',
    musicKit: 'Musiqa toplami',
    patch: 'Yamoq',
    charm: 'Brelok',
    agent: 'Agent',
    knife: 'Pichoq',
    gloves: 'Qoʻlqop',
    item: 'Buyum',
    condition: 'Holati',
    color: 'Rang',
  },
  fa: {
    weapon: 'سلاح',
    sticker: 'استیکر',
    graffiti: 'گرافیتی',
    case: 'کیس',
    capsule: 'کپسول',
    package: 'بسته',
    collection: 'مجموعه',
    musicKit: 'پک موسیقی',
    patch: 'پچ',
    charm: 'آویز',
    agent: 'ایجنت',
    knife: 'چاقو',
    gloves: 'دستکش',
    item: 'آیتم',
    condition: 'وضعیت',
    color: 'رنگ',
  },
  pt: {
    weapon: 'Arma',
    sticker: 'Adesivo',
    graffiti: 'Grafite',
    case: 'Caixa',
    capsule: 'Cápsula',
    package: 'Pacote',
    collection: 'Coleção',
    musicKit: 'Kit de música',
    patch: 'Emblema',
    charm: 'Chaveiro',
    agent: 'Agente',
    knife: 'Faca',
    gloves: 'Luvas',
    item: 'Item',
    condition: 'Condição',
    color: 'Cor',
  },
  tr: {
    weapon: 'Silah',
    sticker: 'Çıkartma',
    graffiti: 'Grafiti',
    case: 'Kasa',
    capsule: 'Kapsül',
    package: 'Paket',
    collection: 'Koleksiyon',
    musicKit: 'Müzik kiti',
    patch: 'Arma',
    charm: 'Anahtarlık',
    agent: 'Ajan',
    knife: 'Bıçak',
    gloves: 'Eldiven',
    item: 'Eşya',
    condition: 'Durum',
    color: 'Renk',
  },
  uk: {
    weapon: 'Зброя',
    sticker: 'Стікер',
    graffiti: 'Графіті',
    case: 'Кейс',
    capsule: 'Капсула',
    package: 'Набір',
    collection: 'Колекція',
    musicKit: 'Музичний альбом',
    patch: 'Нашивка',
    charm: 'Брелок',
    agent: 'Агент',
    knife: 'Ніж',
    gloves: 'Рукавиці',
    item: 'Предмет',
    condition: 'Стан',
    color: 'Колір',
  },
  de: {
    weapon: 'Waffe',
    sticker: 'Aufkleber',
    graffiti: 'Graffiti',
    case: 'Case',
    capsule: 'Kapsel',
    package: 'Paket',
    collection: 'Kollektion',
    musicKit: 'Musikkit',
    patch: 'Aufnäher',
    charm: 'Anhänger',
    agent: 'Agent',
    knife: 'Messer',
    gloves: 'Handschuhe',
    item: 'Item',
    condition: 'Zustand',
    color: 'Farbe',
  },
  es: {
    weapon: 'Arma',
    sticker: 'Pegatina',
    graffiti: 'Grafiti',
    case: 'Caja',
    capsule: 'Cápsula',
    package: 'Paquete',
    collection: 'Colección',
    musicKit: 'Kit de música',
    patch: 'Parche',
    charm: 'Colgante',
    agent: 'Agente',
    knife: 'Cuchillo',
    gloves: 'Guantes',
    item: 'Objeto',
    condition: 'Estado',
    color: 'Color',
  },
  pl: {
    weapon: 'Broń',
    sticker: 'Naklejka',
    graffiti: 'Graffiti',
    case: 'Skrzynka',
    capsule: 'Kapsuła',
    package: 'Zestaw',
    collection: 'Kolekcja',
    musicKit: 'Zestaw utworów',
    patch: 'Naszywka',
    charm: 'Przywieszka',
    agent: 'Agent',
    knife: 'Nóż',
    gloves: 'Rękawice',
    item: 'Przedmiot',
    condition: 'Stan',
    color: 'Kolor',
  },
});
